import { Label } from "@/components/ui/label";

export function Field({ label, full, children }) {
  return (
    <div className={`space-y-2 ${full ? "sm:col-span-2" : ""}`}>
      <Label className="eyebrow">{label}</Label>
      {children}
    </div>
  );
}
